import appConf from '../app-conf'

const setup = appConf[process.env.REACT_APP_CLIENT]
const environment = process.env.NODE_ENV
const project = 'Update'
const server = null
const service = null
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  routes: {
    label: 'Lost Card',
    prefix: '/lostcard',
  },
  endpoints: {
    transfer: {
      headers: {
        'Content-Type': 'application/json',
        Authorization: null,
      },
      doc: '',

      url: setup.setup.api.stormborn.url.api + '/card/hold',
      // url: 'https://subcarduat.tr4ns.com/tx-sub/card/hold',

      method: 'POST',
    },
  },
  setup,
}

export default config
